import { KoobInputCheckbox, KoobLoader } from '@koob/ui';
import ActiveJobTooltip from '../../../../components/ActiveJobTooltip';

export default function BulkEditRequestsSelectorCheckbox({
  request,
  selected,
  setSelected,
  updating,
}) {
  return (
    <div className={['w-full', updating ? 'opacity-60' : ''].join(' ')}>
      <KoobInputCheckbox
        key={request.id}
        checked={selected}
        onCheckedChange={setSelected}
        disabled={updating}
      >
        <div className="flex space-x-2 items-center">
          <div className="leading-none text-sm text-gray-600 font-medium">
            <div>{request?.toOrganization?.name}</div>

            <div className="mt-1 flex space-x-1.5 items-center">
              {updating && (
                <ActiveJobTooltip position="left">
                  <KoobLoader
                    size={16}
                    color="currentColor"
                    className="text-gray-400"
                  />
                </ActiveJobTooltip>
              )}
            </div>
          </div>
        </div>
      </KoobInputCheckbox>
    </div>
  );
}
